import { defineMessages } from 'react-intl';

export default defineMessages({
  fullNutritionLink: {
    defaultMessage: 'Full nutrition & ingredients list',
    description: `Button that links to the pdp's nutrition page`,
    id: 'ordering.pdp.nutritionLink',
  },
  nutritionSummary: {
    id: 'ordering.pdp.nutritionSummary',
    defaultMessage:
      '{caloriesValue} calories, {sugarValue} sugar, {fatValue} fat',
    description: 'Shows calories, sugar and fat as in a nutrition table',
  },
  summaryLabel: {
    id: 'ordering.pdp.summaryLabel',
    defaultMessage: 'Product summary',
    description: 'Aria label on element with description and nutrition summary',
  },
});
